import { createFileRoute } from "@tanstack/react-router";
import { ItemDetailPage } from "@/components/inventory/ItemDetailPage";
import { requireAuth } from "@/lib/require-auth";

export const Route = createFileRoute("/inventory_/$itemId")({
  beforeLoad: () => {
    requireAuth();
  },
  component: ItemDetailPage,
});
